type stringGetter = string | (() => string)

export function useEnumTranslator<T extends string>(transpateMaps: () => Record<T, stringGetter>) {
  const mappp = computed(() => transpateMaps())
  return (val: T | None, fb?: string): stringI18n => {
    const value = getFuncValue(val ? mappp.value[val] : undefined)
    return (value ? ts(value) : undefined) ?? ts(fb) ?? ts('...')
  }
}
